import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import withSiteAndLocale from '../../components/hoc/site-and-locale'

class App extends Component {
  render() {
    const { children } = this.props

    return (
      <div>
        {children}
      </div>
    )
  }
}

App.propTypes = {
  children: PropTypes.node,
}

App.defaultProps = {
  children: '',
  actions: '',
}

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(null, mapDispatchToProps)(
  withSiteAndLocale(App),
)



// WEBPACK FOOTER //
// ./src/containers/app/app.js